import { toast } from 'react-toastify';

const toasts = {
  info(title: string, message: string, onClick: VoidFunction) {
    toast.info(
      <div className='text-container'>
        <b>{title}</b>
        <p>{message}</p>
      </div>,
      { onClick, position: 'bottom-right' },
    );
  },
  error(message = 'Ошибка') {
    toast.error(
      <div className='text-container'>
        <p>{message}</p>
      </div>,
      { position: 'bottom-right' },
    );
  },
  success(message = 'Успешно') {
    toast.success(
      <div className='text-container'>
        <p>{message}</p>
      </div>,
      { position: 'bottom-right' },
    );
  },
  warning(message: string) {
    toast.warning(
      <div className='text-container'>
        <p>{message}</p>
      </div>,
      { position: 'bottom-right' },
    );
  },
};

export default toasts;
